import { useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from 'react-redux';
import Swal from "sweetalert2";
import { authAPI } from "../services/AuthAPI";
import { TextField, CircularProgress } from '@mui/material';
import { makeStyles } from "@material-ui/core/styles";
import Button from "./../components/CustomButtons/Button";
import GridContainer from "./../components/Grid/GridContainer.js";
import GridItem from "./../components/Grid/GridItem.js";
import Card from "./../components/Card/Card.js";
import CardBody from "./../components/Card/CardBody.js";
import CardHeader from "./../components/Card/CardHeader.js";
import CardFooter from "./../components/Card/CardFooter.js";
import styles from "../assets/style/login";
import LogoImage from "../assets/images/login-bg.png"
import './login.css'

const ForegetPasswordConfirm = () => {
    const useStyles = makeStyles(styles);
    const [loading, setLoading] = useState(false)
    const [newPassword, setNewPassword] = useState("")
    const [confirmPassword, setConfirmPassword] = useState("")
    const navigate = useNavigate();
    const { _id } = useParams()
    const { user: { isLogin } } = useSelector(state => state)
    const [cardAnimaton, setCardAnimation] = useState("cardHidden");

    useEffect(() => {
        let cardAnimatonTO = setTimeout(() => {
            setCardAnimation("");
        }, 700);
        return () => {
            clearTimeout(cardAnimatonTO)
            setEmail("")
        }
    }, [isLogin])

    useEffect(() => {
        if (!isLogin) {
            authAPI.ForgetPasswordByID(_id)
                .then((res) => {
                    if (res.status != 200) {
                        Swal.fire({
                            icon: 'error',
                            confirmButtonColor: "#f27474",
                            html: `<span class="colorWhite">${res.message}</span>`,
                            width: '28rem',
                            timer: 5000
                        }).then(() => {
                            navigate("/login")
                        })
                    }
                })
                .catch((error) => {
                    Swal.fire({
                        icon: 'error',
                        confirmButtonColor: "#f27474",
                        html: `<span class="colorWhite">${error.message}</span>`,
                        width: '28rem',
                        timer: 5000
                    }).then(() => {
                        navigate("/login")
                    })
                })
        }
    }, [_id, isLogin])

    const ConfirmChangePassword = (e) => {
        try {
            e.preventDefault()
            if (newPassword != confirmPassword) throw { message: "Password ต้องเหมือนกัน" }
            setLoading(true)
            authAPI.ResetPassword({ _id, newPassword, confirmPassword })
                .then((res) => {
                    setLoading(false)
                    if (res.status == 200) {
                        Swal.fire({
                            icon: 'success',
                            confirmButtonColor: "#6ab23a",
                            html: `<span class="colorWhite">เปลี่ยนรหัสผ่านเรียบร้อยแล้ว</span>`,
                            width: '28rem',
                            timer: 3000
                        }).then(() => {
                            navigate("/login")
                        })
                    }
                    else {
                        Swal.fire({
                            icon: 'error',
                            confirmButtonColor: "#f27474",
                            html: `<span class="colorWhite">${res.message}</span>`,
                            width: '28rem',
                            timer: 3000
                        });
                    }
                })
        } catch (error) {
            Swal.fire({
                icon: 'error',
                confirmButtonColor: "#f27474",
                html: `<span class="colorWhite">${error.message}</span>`,
                width: '28rem',
                timer: 3000
            });
        }
    }

    const classes = useStyles();

    return (
        !isLogin && <div onSubmit={ConfirmChangePassword}>
            <div 
                className={`${classes.pageHeader} pageHeader`}
                style={{
                    // backgroundSize: "cover",
                    // backgroundPosition: "top center",
                    display: "grid",
                    gridTemplateColumns: "60% 40%",
                    gridTemplateRows: "100%",
                    padding: "0%",
                    margin: "0%",
                    width: '100vw',
                    height: '100vh',
                }}
            >
                <div className={`${classes.colleft} col-left`}>
                    <img className="wave" src={LogoImage} alt="" />
                    <h5 style={{ color: '#212529', fontSize: '18px', opacity: '75%' }}>Human Resources (HR)</h5>
                    <h3 style={{ color: '#212529', fontSize: '25px', fontWeight: 600 }}>HR Com7 Documentary</h3>
                </div>

                <div className={`${classes.container} col-right`}>
                    <GridContainer justifyContent="center">
                        <GridItem >
                            <Card className={classes[cardAnimaton]} style={{ borderRadius: '4px', boxShadow: 'none' }}>
                                <form className={classes.form}>
                                    <CardHeader color="primary" className={`${classes.cardHeader} enter-cardHeader`}>
                                        <h3 style={{ color: '#212529', fontSize: '30px', textAlign: 'center', fontWeight: 600 }}>อัพเดต รหัสผ่านของคุณ</h3>
                                    </CardHeader>
                                    
                                    <CardBody style={{ marginTop: '6%'}}>
                                        <TextField type={"password"} style={{ width: '100%' }} value={newPassword} onChange={(e) => setNewPassword(e.target.value)} label="รหัสผ่านใหม่" variant="standard" className={classes.UnderLine} />
                                        <TextField type={"password"} style={{ width: '100%', margin: '25px 0px' }} value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} label="ยืนยัน รหัสผ่านใหม่" variant="standard" className={classes.UnderLine} />

                                    </CardBody>
                                    <CardFooter className={classes.cardFooter} style={{ justifyContent: 'flex-end !important', marginLeft: '3%', marginRight: '3%' }}>
                                        {!loading ? <Button className={classes.cardButton} simple type="submit" color={`${(newPassword == "" || confirmPassword == "") ? "danger" : "primary"}`} style={{
                                            width: '127px',
                                            height: '32px',
                                            fontWeight: 600,
                                            borderRadius: '24px',
                                            color: 'white',
                                            backgroundColor: (newPassword == "" || confirmPassword == "") ? "lightgray" : '#6ab23a'
                                        }} size="lg"
                                            disabled={(newPassword == "" || confirmPassword == "") ? true : false}
                                            onClick={ConfirmChangePassword}>
                                            อัพเดตรหัสผ่าน
                                        </Button> : <Button className={classes.cardButton} simple type="submit" color={"primary"} style={{
                                            borderRadius: '4px',
                                            color: 'white',
                                            backgroundColor: "lightgray"
                                        }} size="lg"
                                            disabled={true}
                                        >
                                            <CircularProgress size={30} style={{ color: '#6ab23a' }} />
                                        </Button>}
                                    </CardFooter>
                                </form>
                            </Card>
                        </GridItem>
                    </GridContainer>
                </div>
            </div>
        </div>
    )
}
export default ForegetPasswordConfirm